import { FC } from 'react';

import { Card, Text, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

const ErirClassificationTip: FC = () => {
    const trl = useTrls();

    return (
        <>
            <Card padding={12} borderRadius={12} stretched style="dreamy-secondary">
                <Text>{trl('AdCreate.AdForm.ErirClassification.tip')}</Text>
            </Card>
            <VSpacing default={32} />
        </>
    );
};

export default ErirClassificationTip;
